import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default class CreditActivity extends ApplicationSerializer {
  normalizeArrayResponse(store, primaryModelClass, {
    activities,
    cursor
  }, id, requestType) {
    const normalizedResponse = super.normalizeArrayResponse(store, primaryModelClass, activities || [], id, requestType);
    normalizedResponse.meta = {
      cursor
    };
    return normalizedResponse;
  }
}